export { HeaderKimetsu } from './HeaderKimetsu';
export { BodyKimetsu } from './BodyKimetsu';
export { FooterKimetsu } from './FooterKimetsu';
